import React, { useState, useEffect, useRef } from "react";

import { 
  Campaign, 
  QuestBoard,
} from "@dndModels";

import DandDAPI from "@dndUtilities/system_api";
import DandDCharacterUtilities from "@dndUtilities/char_utilities";
import CharConnectUtilities from "@dndUtilities/char_connect_utilities";
import { makeStyles } from "@utilities/theme_utilities";

import EditableLabel from "@components/input/strings/EditableLabel";
import DeleteButton from "@components/input/buttons/icon_buttons/DeleteButton";
import ModalOrDrawer from "@components/display/ModalOrDrawer";
import FlexBox from "@components/layout/FlexBox";
import StringBox from "@components/input/strings/StringBox";
import DandDButtonBox from "@dndComponents/DandDButtonBoxSimple";
import DisplayQuestBoard from "./DisplayQuestBoard";

interface Props {
  campaign: Campaign;
  quest_board: QuestBoard;
  onDelete: () => void;
}

const api = DandDAPI.getInstance();
const char_util = DandDCharacterUtilities.getInstance();
const connect_util = CharConnectUtilities.getInstance();

export default function QuestBoardInput({ campaign, quest_board, onDelete }: Props) {
  const [reloading, setReloading] = useState(false);
  // const [processing, setProcessing] = useState(false);
  // const [ping, setPing] = useState(false);
  // const [open, setOpen] = useState(quest_board.name.length === 0);
  const [display_it, setDisplayIt] = useState(false);
  const mounted = useRef(false);

  useEffect(() => { 
    mounted.current = true;

    return () => {
      mounted.current = false;
    };
  }, []);
    
  useEffect(() => {
    if (reloading) {
      setReloading(false);
    }
  }, [reloading, setReloading]);
  
  const useStyles = makeStyles()((theme) => {
    return ({
      root: {
        backgroundColor: theme.palette.secondary.main,
        border: `1px solid ${theme.palette.divider}`,
        borderRadius: '4px',
        marginBottom: '4px',
      },
    });
  });

  const { classes, cx } = useStyles();

  const renderExtras = () => {
    return (
      <>
        {/* <ModalOrDrawer
          open={open}
          full_page
          onClose={() => { setOpen(false); }}>
          { renderInputControls() }
        </ModalOrDrawer> */}
        <ModalOrDrawer
          open={display_it}
          full_page
          onClose={() => { setDisplayIt(false); }}>
          <DisplayQuestBoard
            campaign={campaign}
            quest_board={quest_board}
          />
        </ModalOrDrawer>
      </>
    )
  }

  // const renderInputControls = () => {
  //   return (
  //     <FlexBox direction="column">
  //       <FlexBox>
  //         <EditableLabel
  //           name="Name"
  //           value={quest_board.name}
  //           fontSize={24}
  //           onChange={ async (changed: string) => {
  //             quest_board.name = changed;
  //             api.upsertObject("campaign_quest_board", quest_board);
  //             setPing(!ping);
  //           }}
  //         />
  //       </FlexBox>
  //       <FlexBox>
  //         <StringBox
  //           name="Header"
  //           value={quest_board.header}
  //           onChange={ async (changed: string) => {
  //             quest_board.header = changed;
  //             api.upsertObject("campaign_quest_board", quest_board);
  //             setPing(!ping);
  //           }}
  //         />
  //       </FlexBox>
  //       <FlexBox>
  //         <StringBox
  //           name="Subheader"
  //           value={quest_board.subheader}
  //           multiline
  //           onChange={ async (changed: string) => {
  //             quest_board.subheader = changed;
  //             api.upsertObject("campaign_quest_board", quest_board);
  //             setPing(!ping);
  //           }}
  //         />
  //       </FlexBox>
  //       <FlexBox>
  //         <StringBox
  //           name="Board Note"
  //           value={quest_board.board_note}
  //           multiline
  //           onChange={ async (changed: string) => {
  //             quest_board.board_note = changed;
  //             api.upsertObject("campaign_quest_board", quest_board);
  //             setPing(!ping);
  //           }}
  //         />
  //       </FlexBox>
  //     </FlexBox>
  //   );
  // }

  return (
    <div className="padded">
      <FlexBox direction="column" className={cx(classes.root)}>
        <FlexBox direction="row">
          <FlexBox className="header padded clickable" onClick={() => {
            setDisplayIt(true); 
          }}>{ quest_board.name }</FlexBox>
          <FlexBox xs_expand={0} className="centered">
            <div style={{ float: "right"}}>
              <DeleteButton
                no_fab
                obj_name={quest_board.name}
                onClick={onDelete}
              />
            </div>
          </FlexBox>
        </FlexBox>
      </FlexBox>
      { renderExtras() }
    </div>
  );
}
